import { createStore } from "vuex";

export default createStore({
  state() {
    return {};
  },
  mutations: {},
  actions: {},
  modules: {},
});
